//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ImageTextLeft',
  props: {
    section: {
      type: Object
    },
    roundType: {
      type: String,
      default: ''
    }
  }
}
